export const BackendResponsePerformanceCategoryConst = {
    finishedPerformance: 'FinishedPerformance',
    rerun: 'Rerun',
    archive: 'Archive'
}

export default BackendResponsePerformanceCategoryConst;